<!-- TileContent.vue -->
<template>
    <div class="tile-content-wrapper">
        <div class="header">
            <h3>{{ site.title }} - {{ site.type }}</h3>
            <i class="fa-solid fa-xmark close-icon" @click="closeSiteDetails()"></i>
        </div>

        <div class = "main-content">
            <!-- Live icon (flashing) -->
            <div style="position: relative;padding-left:20px; padding-bottom: 20px;">
                <span style="color:red; font-weight: bold;">LIVE DATA</span>
                <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                    <circle cx="20" cy="20" r="5" fill="red" />
                </svg>
            </div>
            <h4 >Tank Report</h4>
            <b-container>
                <b-row >
                    <b-col>
                        <div class="site-summary-item"><span style="color: green">Normal</span></div>
                        <div class="site-summary-header" v-b-popover.hover.top="'As measured by checking the Oxygen levels'" title="O₂ Levels">O₂ LEVELS<span style="position: absolute; font-size: .75em; padding-left: 1px; padding-bottom: -10px;"><i class="fa-solid fa-circle-info"></i></span></div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><span style="color: green">Normal</span></div>
                        <div class="site-summary-header" v-b-popover.hover.top="'As measured by checking the OxygCarbon dioxide levels'" title="CO₂ Levels">CO₂ LEVELS<span style="position: absolute; font-size: .75em; padding-left: 1px; padding-bottom: -10px;"><i class="fa-solid fa-circle-info"></i></span></div>
                    </b-col>
                    <b-col >
                        <div class="site-summary-item"><span style="color: green">Clean</span></div>
                        <div class="site-summary-header">WATER QUALITY</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><span style="color: green">High</span></div>
                        <div class="site-summary-header">FEED QUALITY</div>
                    </b-col>
                </b-row>
            </b-container>
            <hr />
            <h4>Site Details</h4>
            <b-container>
                <b-row >
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-fish-fins"></i> {{site.stock}}</div>
                        <div class="site-summary-header">STOCK LEVELS</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-users"></i> {{ site.staff }}</div>
                        <div class="site-summary-header">STAFF</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-dollar-sign"></i>{{ site.revenue }}M</div>
                        <div class="site-summary-header">REVENUE</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item" href="tasksModal" v-b-modal.tasksModal role="button"><i class="fa-solid fa-tasks"></i> {{getActiveTasksForSite()}} </div>
                        <div class="site-summary-header"></div>
                            <div class="site-summary-header" href="tasksModal" v-b-modal.tasksModal role="button">TASKS</div>
                            <b-modal id="tasksModal" size="xl" title="Tasks">
                                <TasksContent :site="site" :showLocationFilters="false"> </TasksContent>
                            </b-modal>
                    </b-col>
                </b-row>
            </b-container>
            <hr />
            <h4>Site Weather</h4>
            <b-container>
                <b-row >
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-temperature-low"></i> {{ weatherData.current.temperature_2m }}{{ weatherData.current_units.temperature_2m }}</div>
                        <div class="site-summary-header">TEMPERATURE</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-cloud-rain"></i> {{ weatherData.current.precipitation }}{{ weatherData.current_units.precipitation }}</div>
                        <div class="site-summary-header">RAINFALL</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item">{{ weatherData.current.relativehumidity_2m }}{{ weatherData.current_units.relativehumidity_2m }}</div>
                        <div class="site-summary-header">RELATIVE HUMIDITY</div>
                    </b-col>
                    <b-col>
                        <div class="site-summary-item"><i class="fa-solid fa-wind"></i> {{ weatherData.current.windspeed_10m }} {{ weatherData.current_units.windspeed_10m }}</div>
                        <div class="site-summary-header">WINDSPEED</div>
                    </b-col>
                </b-row>
            </b-container>
            <hr />
            <div >
                <h4 style="padding-bottom: 10px; top: 0;">Site Reports</h4>
                <div>
                    <div class="site-summary-item"><b-button size="sm" @click="showReport" variant="primary" :disabled="!fish_neos_year_class.length" style="margin-bottom: 10px" >View Report</b-button> </div>
                    <div class="site-summary-header">Neo Audit '24 Spawn</div>
                </div>
            </div>
            <hr />
            <div class="map-container" style="display: none; position: relative; float: right; max-height: 200px;">
                <!-- device location desktop -->
                <div id="device-location-desktop"
                    style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                    <h4>Location</h4>
                    <!-- <PackagingTracking ref="PackagingTracking"/> -->
                    <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" />
                </div>
                <!-- device location mobile -->
                <div id="device-location-mobile" style="display: inline-block; width: 100%; padding: 0px; float: left;">
                    <h4>Location</h4>
                    <!-- <PackagingTracking ref="PackagingTracking"/> -->
                    <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" />
                </div>
            </div>
            
            <div id="charts-container" class="charts-container">
                <highcharts :options="siteWeatherChartOptions" :updateArgs="updateArgs"></highcharts>
            </div>
        </div>
        <b-modal size="xl" ref="SiteReportModal" style="display: none;">
            <!-- <div> -->
                <Grid id="fishBatchData_grid" 
                    :data-items="fish_neos_year_class"
                    :style="{ 'font-size': '13px','height': 'calc(100vh - 220px)' }"
                    :loader="loader"
                    :columns="reportColumns">
                </Grid>
            <!-- </div> -->
        </b-modal>
    </div>
</template>

<script>

import axios from "axios";
import PackagingTracking_dynamic from '../PackagingTracking_dynamic.vue';
import { Grid } from '@progress/kendo-vue-grid';
import TasksContent from "./TasksContent.vue";

export default {
    name: 'site-details',
    components: {
        PackagingTracking_dynamic,
        Grid,
        TasksContent
    },
    data: function () {
        return {
            showModal: false,
            item: {coords: {lat: this.site.location.latitude, lng: this.site.location.longitude}},
            forecast_days: 3,
            weatherAPI: {
                base_url: 'https://api.open-meteo.com/v1/',
                resource: 'forecast',
                options: 'current=temperature_2m,windspeed_10m,relativehumidity_2m,precipitation&hourly=temperature_2m,relativehumidity_2m,windspeed_10m'
            },

            weatherData: {
                "latitude": -42.75,
                "longitude": 147.125,
                "generationtime_ms": 0.05793571472167969,
                "utc_offset_seconds": 0,
                "timezone": "GMT",
                "timezone_abbreviation": "GMT",
                "elevation": 19.0,
                "current_units": {
                    "time": "iso8601",
                    "interval": "seconds",
                    "temperature_2m": "°C",
                    "windspeed_10m": "km/h",
                    "relativehumidity_2m": "%"
                },
                "current": {
                    "time": "2023-10-26T02:15",
                    "interval": 900,
                    "temperature_2m": 11.7,
                    "windspeed_10m": 21.1,
                    "relativehumidity_2m": 50
                },
                "hourly_units": {
                    "time": "iso8601",
                    "temperature_2m": "°C",
                    "relativehumidity_2m": "%",
                    "windspeed_10m": "km/h"
                },
                "hourly": {
                    "time": [
                        "2023-10-26T00:00",
                    ],
                    "temperature_2m": [
                        10.2,
                    ],
                    "relativehumidity_2m": [
                        54,
                    ],
                    "windspeed_10m": [
                        19.6,
                    ]
                }
            },

            /* HighCharts Setup */
            weatherDataSeries: [],
            updateArgs: [true, true, { duration: 1000 }],
            siteWeatherChartOptions: {
                chart: {
                    type: 'spline',
                    marginRight: 80, // like left
                    height: '50%',
                    zoomType: 'x',
                    resetZoomButton: {
                        position: {
                            // align: 'right', // by default
                            // verticalAlign: 'top', // by default
                            x: 0,
                            y: -30,
                        },
                    },
                },
                time: { useUTC: false, timezone: 'Australia/Melbourne', },
                rangeSelector: { enabled: false, },
                title: {
                    text: 'Site Temperature Data'
                },
                // exporting: { enabled: true, showTable: false, filename: 'BatchReplay_' + this.item.id + '_' + this.BatchID },
                series: this.weatherDataSeries,
                legend: { enabled: true, },
                xAxis: [{
                    type: 'datetime',
                    //labels: { format: '{value:%Y-%m-%d}', },
                    title: { text: 'Time' },
                }],
                yAxis: [{ opposite: false, title: { text: 'Temperature' } }, { opposite: true, title: { text: 'Relative Humidity' } }],
            },
            fish_neos_year_class: [],
            loader: false,
            reportColumns: [
                //   { field: 'Playback', title: 'Playback', width: 70 },
                    { field: 'tag_id', title: 'Tag ID', width: 100 },
                    { field: 'year_class', title: 'Year Class', width: 120 },
                    { field: 'hatchery', title: 'Hatchery' },
                    { field: 'tank', title: 'Tank' },
                    { field: 'comment', title: 'Comment' },
                    { field: 'maturation_2024', title: "Maturation '24" },
                    { field: 'AGD', title: 'AGD', /*cell: this.cellWithBackground */},
                    { field: 'summer_growth', title: 'Summer Growth' },
                    { field: 'HoG', title: 'HoG' },
                    { field: 'DJ_risk', title: 'DJ Risk' },
                    { field: 'index_dec_2023', title: "Index,  (Dec '23)" },
                    { field: 'implant_date', title: 'Implant Date' },
                    { field: 'feed', title: 'Feed' },
                    { field: 'spawned_2024', title: "Spawned '24" },
            ],
            /* HighChards Setup */
            tasks: [],
        };
    },
    props: ['site'],
    mounted: async function () {
        await this.getTasksFromDB();
        await this.getLocationWeatherReport(this.site);
        
        if (this.site.title == 'Springfield') await this.getFishNeosReport(this.site);
    },
    methods: {
        async getTasksFromDB() {
            this.loading = true;   
            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_AQUACULTURE_TASKS_API_URI + "/items",
                    JSON.stringify({}),
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                );
                this.tasks = response.data;
            } 
            catch (error) {
                console.log(error);
            }
            this.loading = false;
        },
        async getLocationWeatherReport(site) {
            let response = await axios.get(`${this.weatherAPI.base_url}${this.weatherAPI.resource}?${this.weatherAPI.options}&latitude=` + site.location.latitude + '&longitude=' + site.location.longitude + '&forecast_days=' + this.forecast_days)

            var responseData = response.data;

            // console.log(responseData);
            
            this.weatherData = responseData;

            var temp = [];
            var humidity = [];
            var windspeed = [];

            const today = Date.now();
            var forecastStart;
            var forecastEnd;

            for (var i = 0; i < responseData.hourly.time.length; i++) {
                const timestamp = Date.parse(responseData.hourly.time[i])

                humidity.push([timestamp, responseData.hourly.relativehumidity_2m[i]]);
                temp.push([timestamp, responseData.hourly.temperature_2m[i]]);
                windspeed.push([timestamp, responseData.hourly.windspeed_10m[i]]);

                // Retrieve the start and end of the 'forecast' zone
                if (timestamp >= today && forecastStart === undefined) forecastStart = timestamp;
                if (i == responseData.hourly.time.length -1) forecastEnd = timestamp;
            }

            this.weatherDataSeries = [{
                name: 'Temperature (°C)',
                data: (temp.length == 0 ? [] : temp),
                yaxis: 1,
            },
            {
                name: 'Relative Humidity (%)',
                data: (humidity.length == 0 ? [] : humidity),
                yaxis: 0,
                type: 'line',
                opposite: true
            },
            {
                name: 'Windspeed (km/h)',
                data: (windspeed.length == 0 ? [] : windspeed),
                yaxis: 1,
                type: 'bar'
            }];

            /* Sets the 'forecast zone' */
            this.siteWeatherChartOptions.xAxis[0].plotLines = [{
                dashStyle: 'dash',
                color: 'Black',
                width: 2,
                value: forecastStart,
            }];
            this.siteWeatherChartOptions.xAxis[0].plotBands = [
                {
                    color: 'rgba(75, 66, 255, 0.07)',
                    from: forecastStart,
                    to: forecastEnd,
                    label: { text: "Forecast (" + this.forecast_days + " days)" },
                },
                {
                    color: 'rgba(75, 66, 255, 0)',
                    from: Date.parse(responseData.hourly.time[0]),
                    to: forecastStart,
                    label: { text: 'Today' },
                }
            ];
            
            // console.log(this.weatherDataSeries)
            this.siteWeatherChartOptions.series = this.weatherDataSeries;
        },
        async getFishNeosReport() {
            try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_AQUACULTURE_NEO_FISH_REPORT_API_URI + "/items",
                        JSON.stringify({}),
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    this.fish_neos_year_class = response.data;
                } catch (error) {
                    console.log(error);
                }

                // console.log("Retrieved fish report data: ", this.fish_neos_year_class)
        },
        showReport() {
            this.$refs.SiteReportModal.show();
        },
        closeSiteDetails(){
            this.$emit('toggle-content');
        },
        getActiveTasksForSite(){ 
            return  this.tasks.filter(task => task.status !== 'Canceled' && task.location == this.site.title && (this.showCompletedTasks || task.status !== 'Completed')).length;
        },
        // cellWithBackground: function (h, tdElement , props, listeners ) {
        //     console.log("Rendering cell... h: ", h, " tdElement: ", tdElement, " props: ", props, " listeners: ", listeners)
        //     const value = props.dataItem;
        //     if (props.field == "AGD") {
        //         if (value > 40) 
        //         {
        //             return h('td', 
        //                 {
        //                     style:{"background-color": "rgb(55, 180, 0,0.32)"}
        //                 }, 
        //                 [value]);
        //         }
        //     }
        //     console.log("Cell Value: ", value)
        // }

    },
};
</script>

<style scoped>

    .charts-container {
        float: left;
        position: relative;
        width: 100%;
        padding-top: 20px
    }

    .map-container {
        float: right;
        position: relative;
        max-width: 40%;
        width: 50%;
    }

    /* Apply some basic styles to the header */
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: none;
        background-color: transparent;
        color: #000000;
        margin-bottom: 10px;
    }

    /* Style the title text */
    .header h3 {
        margin: 0;
        padding: 0;
    }

    /* Style the 'X' icon */
    .close-icon {
        cursor: pointer;
        font-size: 24px;
        transition: transform 0.2s;
    }

    .close-icon:hover {
        transform: scale(1.2); /* Grow the icon on hover */
        transition: transform 0.2s;
    }

    .flex-container { 
        justify-content: space-evenly; 
    }

    .site-summary { 
        min-width: 150px; 
    }

    .site-summary-header { 
        margin-top: -7px; 
        margin-bottom: 5px; 
        color: grey; 
    }

    .site-summary-item { 
        font-size: 39px; 
        color: #6c757d; 
        font-weight: 200; 
    }

    @media (max-width: 767px) {
        .flex-container {
            justify-content: left;
            display: table; 
        }

        .tile-content-wrapper{ 
            max-width: 100%; 
        }

        #charts-container { 
            display: none; 
        }

        i.fa-xmark { 
            font-size: 1.5em; 
        }

        .site-summary-item { 
            font-size: 22px; 
            color: #6c757d; 
            font-weight: 200; 
            min-width: 100px;
            min-height: 30px;
            margin-bottom: 5px
        }

        .site-summary-header { 
            margin-top: -7px; 
            margin-bottom: 5px; 
            color: grey; 
            font-size: 10px; 
        }
    }

</style>

